module.exports = __webpack_public_path__ + "img/down.4224347b.png";